module.exports = __webpack_public_path__ + "static/assets/a2f2f3a8d547ed146674af72dde149a4.png";